import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, children }) {
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, []);

  return (
    <main className="min-h-screen bg-background text-foreground">
      <header className="border-b border-white/10">
        <div className="max-w-4xl mx-auto px-5 md:px-10 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="/vpt-logo.png" alt="VPT Engineering" className="h-9 md:h-10 w-auto" />
          </Link>
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 text-sm uppercase tracking-widest text-white/60 hover:text-primary transition-colors"
          >
            <ArrowLeft className="h-4 w-4" /> Startseite
          </Link>
        </div>
      </header>

      <section className="max-w-4xl mx-auto px-5 md:px-10 py-16 md:py-24">
        <h1 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl mb-12">
          {title}
        </h1>
        <div className="space-y-8 text-white/70 leading-relaxed">{children}</div>
      </section>
    </main>
  );
}
